/* Red Line homepage, lower half: behaviour. Styles: pa-rl-home-lower.css.
   Loaded by sections/homepage-range-pack-offer.liquid (homepage-only); safe to load
   twice (e.g. also from the hero's Red Line loader).
   - Buyer quotes: a native scroll-snap row instead of the Flickity carousel, with
     prev/next arrows for mouse users (same behaviour as the product page's
     pa-rl-sections.js). Homepage only; testimonials.liquid is shared with product pages.
   Idempotent. */
(function () {
  'use strict';

  if (window.__paRlHomeLower) return;
  window.__paRlHomeLower = true;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function arrowSvg(dir) {
    var d = dir === 'prev' ? 'M15 4 7 12l8 8' : 'M9 4l8 8-8 8';
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="square"/></svg>';
  }

  function settle(component, row) {
    var nav = component.flickityNav || (window.Flickity && window.Flickity.data && window.Flickity.data(row));
    if (nav && typeof nav.destroy === 'function') {
      try { nav.destroy(); } catch (e) { /* already gone */ }
    }
    component.flickityNav = null;
    row.removeAttribute('style');
    $$('.testimonial__preview', row).forEach(function (cell) {
      cell.style.removeProperty('position');
      cell.style.removeProperty('left');
      cell.style.removeProperty('transform');
      cell.removeAttribute('aria-hidden');
    });
  }

  function quotes() {
    if (!document.body || !document.body.classList.contains('template-index')) return;

    $$('.testimonials-wrapper--buyer-card testimonials-component').forEach(function (component) {
      var row = $('.testimonial__previews', component);
      if (!row || component.dataset.rlDone) return;
      component.dataset.rlDone = '1';

      // Flickity starts when the section nears the viewport. Undo it in the
      // same task, before the browser paints, so the carousel never shows.
      settle(component, row);
      new MutationObserver(function () {
        if (row.classList.contains('flickity-enabled')) settle(component, row);
      }).observe(row, { attributes: true, attributeFilter: ['class'] });

      row.setAttribute('tabindex', '0');
      row.setAttribute('role', 'region');
      row.setAttribute('aria-label', 'Buyer quotes, scroll sideways for more');

      var cells = $$('.testimonial__preview', row);
      if (cells.length < 2) return;
      var host = component.closest('.testimonials');
      if (!host || $('.pa-rl-quotes-nav', host)) return;

      var nav = document.createElement('div');
      nav.className = 'pa-rl-quotes-nav';
      var prev = document.createElement('button');
      prev.type = 'button';
      prev.setAttribute('aria-label', 'Previous quotes');
      prev.innerHTML = arrowSvg('prev');
      var next = document.createElement('button');
      next.type = 'button';
      next.setAttribute('aria-label', 'Next quotes');
      next.innerHTML = arrowSvg('next');
      nav.appendChild(prev);
      nav.appendChild(next);
      host.appendChild(nav);

      function step() {
        var first = cells[0];
        var gap = parseFloat(getComputedStyle(row).columnGap) || 0;
        return first ? first.getBoundingClientRect().width + gap : row.clientWidth;
      }
      function sync() {
        var max = row.scrollWidth - row.clientWidth - 2;
        prev.disabled = row.scrollLeft <= 2;
        next.disabled = row.scrollLeft >= max;
      }
      prev.addEventListener('click', function () {
        row.scrollBy({ left: -step(), behavior: REDUCED ? 'auto' : 'smooth' });
      });
      next.addEventListener('click', function () {
        row.scrollBy({ left: step(), behavior: REDUCED ? 'auto' : 'smooth' });
      });
      var raf = 0;
      row.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; sync(); });
      }, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', quotes);
  else quotes();

  // Theme editor: re-run when a section is re-rendered.
  document.addEventListener('shopify:section:load', quotes);
})();
